import { render, staticRenderFns } from "./ProblemStatement.vue?vue&type=template&id=ceeb93ae&scoped=true"
import script from "./ProblemStatement.vue?vue&type=script&lang=js"
export * from "./ProblemStatement.vue?vue&type=script&lang=js"
import style0 from "./ProblemStatement.vue?vue&type=style&index=0&id=ceeb93ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeb93ae",
  null
  
)

export default component.exports